import { writable } from "svelte/store";

export const loading = writable(0);